import React from 'react';
import { Chip } from '@material-ui/core';
import styled from 'styled-components';
const FlatChipStandard = styled((props) => React.createElement(Chip, Object.assign({ variant: "outlined", size: "small" }, props))) `
    && {
        border: none;
    }
`;
const FlatChipTertiary = styled(FlatChipStandard) `
    && {
        color: ${(props) => props.theme.colors.textTertiary};
    }
`;
const FlatChipUppercaseTertiary = styled(FlatChipTertiary) `
    text-transform: uppercase;
`;
export default {
    Standard: FlatChipStandard,
    Tertiary: FlatChipTertiary,
    UppercaseTertiary: FlatChipUppercaseTertiary
};
//# sourceMappingURL=index.js.map